import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

const _vendors = [];
const sanitise = ({id, ...vendor}) => ({
    id: Number(id),
    ...vendor
});

var VendorStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return {remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _vendors.filter((e) => (e !== undefined));
    },
    getById: function(id) {
        id = Number(id);
        return _vendors.find((e) => (e !== undefined && e.id === id));
    },
    add: function(vendor) {
        vendor = sanitise(vendor);
        const index = _vendors.findIndex((e) => (e !== undefined && e.id === vendor.id) );
        if (0 <= index) {
            _vendors[index] = vendor;
        } else {
            _vendors.push(vendor);
        }
    },
    remove: function(id) {
        id = Number(id);
        const index = _vendors.findIndex((e) => (e !== undefined && e.id === id));
        if (0 <= index) {
            delete _vendors[index];
        }
    },

});

VendorStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.VENDOR_LIST:
            action.data.forEach(VendorStore.add);
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_LIST_ERROR:
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_SAVE:
            VendorStore.add(action.data);
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_SAVE_ERROR:
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_INFO:
            VendorStore.add(action.data);
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_INFO_ERROR:
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_UPDATE:
            VendorStore.add(action.data);
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_UPDATE_ERROR:
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_DELETE:
            if (!!action.data.deleted) {
                VendorStore.remove(action.data.id);
            }
            VendorStore.emitChange();
            break;

        case ActionTypes.VENDOR_DELETE_ERROR:
            VendorStore.emitChange();
            break;

        default:
            break;
    }

});

export default VendorStore;
